import { useEffect, useRef } from 'react';
import { performAssessmentHooks } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'store';


const useSyncPendingUploads = () => {
    const performSync = performAssessmentHooks.usePerformSyncUploads();
    const hasAutoSyncedRef = useRef(false);
    const performSyncRef = useRef(performSync);
    const dispatch = useDispatch()
    const { uploadingAssessmentIds, isInAssessmentMode } = useSelector(state => state.assessment)

    useEffect(() => {
        performSyncRef.current = performSync;
    }, [performSync]);

    useEffect(() => {
        if (hasAutoSyncedRef.current) {
            return;
        }

        hasAutoSyncedRef.current = true;

        const syncTimeout = setTimeout(() => {
            performSyncRef.current();
        }, 10000); // 10 שניות השהייה

        return () => clearTimeout(syncTimeout);
    }, []);


    useEffect(() => {
        // התנאי מתקיים כאשר הגענו ממצב של ביצוע אבחון והסתיימו העלאות של הקבצים
        // נראה לעלות שוב את הקבצים שנתקעו בהעלאה
        if (!uploadingAssessmentIds.length)
            if (isInAssessmentMode) {
                dispatch(actions.setIsInAssessmentMode(false))
                performSyncRef.current();
            }
    }, [uploadingAssessmentIds, isInAssessmentMode, dispatch])
};

export default useSyncPendingUploads;